import(/* webpackMode: "eager", webpackExports: ["OrderHistoryPageContainer"] */ "/vercel/path0/apps/portals/src/app/[portalSlug]/(main)/orders/container.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/portals/src/components/AppPage/AppPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AdminPageHeader"] */ "/vercel/path0/packages/@wolfejs/ms-ui/AdminPageHeader/AdminPageHeader.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/@wolfejs/ui/Spinner/Spinner.tsx");
